import React, { useState } from 'react';
import { Button } from '@mui/material';
import fetch from 'cross-fetch';
import { AccountApiResponse, Plans, SignupPageStep } from '../..';
import { appConfig } from '../../../common/ConfigLoader';
import {
  PlanCardProps,
  basePlans,
} from '../../../component/parentPortal/planCard/planCard';
import { useAppSelector } from '../../../store/hooks';
import {
  selectAppAuthentication,
  setAppPageStep,
} from '../../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../../store/store';

// DEPRECATED
// export enum SubscriptionPlanLabel {
//   MonthlyPlan = 'Monthly Plan',
//   SixMonthPlan = 'Six-month Plan',
//   YearlyPlan = 'Yearly Plan',
// }
//
// export enum SubscriptionPlanPrice {
//   MonthlyPlan = 'HKD $599',
//   SixMonthPlan = 'HKD $2,874',
//   YearlyPlan = 'HKD $4,308',
// }

export interface ChooseYourPlanElementInterface {
  yearlyPlanButton: JSX.Element;
  monthlyPlanButton: JSX.Element;
  sixMonthPlanButton: JSX.Element;
  backButton: JSX.Element;
  planList: PlanCardProps[];
  selectedPlan?: Plans;
  resetSelectedPlan: () => void;
}

export const ChooseYourPlanElement = (): ChooseYourPlanElementInterface => {
  const [selectedPlan, setSelectedPlan] = useState<Plans | undefined>(() => {
    return (localStorage.getItem('selectedPlan') as Plans) ?? undefined;
  });

  // Handlers
  const choosPlanButtonClickHandler = (subscriptionPlanName: Plans): void => {
    setSelectedPlan(subscriptionPlanName);
    localStorage.setItem('selectedPlan', subscriptionPlanName);
  };

  const planList = [
    {
      ...basePlans[Plans.bblProjectAlphaBiyearly],
      onClick(): void {
        choosPlanButtonClickHandler(Plans.bblProjectAlphaBiyearly);
      },
    },
    {
      ...basePlans[Plans.bblProjectAlphaYearly],
      onClick(): void {
        choosPlanButtonClickHandler(Plans.bblProjectAlphaYearly);
      },
    },
    {
      ...basePlans[Plans.bblProjectAlpha],
      onClick(): void {
        choosPlanButtonClickHandler(Plans.bblProjectAlpha);
      },
    },
  ];

  return {
    yearlyPlanButton: (
      <Button
        variant="contained"
        sx={{ width: 'inherite' }}
        fullWidth={true}
        onClick={(): void => {
          // DEPRECATED on 10 Nov 2022
          // choosPlanButtonClickHandler(SubscriptionPlanName.YearlyPlan);
        }}
      >
        Choose Plan
      </Button>
    ),

    monthlyPlanButton: (
      <Button
        variant="contained"
        sx={{ width: 'inherite' }}
        fullWidth={true}
        onClick={(): void => {
          // DEPRECATED on 10 Nov 2022
          // choosPlanButtonClickHandler(SubscriptionPlanName.MonthlyPlan);
        }}
      >
        Choose Plan
      </Button>
    ),

    sixMonthPlanButton: (
      <Button
        variant="contained"
        sx={{ width: 'inherite' }}
        fullWidth={true}
        onClick={() => {
          // DEPRECATED on 10 Nov 2022
          // choosPlanButtonClickHandler(SubscriptionPlanName.SixMonthPlan);
        }}
      >
        Choose Plan
      </Button>
    ),

    backButton: (
      <Button
        variant="text"
        sx={{ width: 'inherite' }}
        fullWidth={true}
        onClick={() => {
          console.debug('CLICKED BACK BUTTON');
          outsideComponentDispatch(
            setAppPageStep(SignupPageStep.YOUR_CHILD_AGE),
          );
        }}
      >
        Back
      </Button>
    ),

    planList,
    selectedPlan,
    resetSelectedPlan() {
      setSelectedPlan(undefined);
      localStorage.removeItem('selectedPlan');
    },
  };
};
